import { TypographyOptions } from "@mui/material/styles/createTypography";

const arcadisTypography: TypographyOptions = {
  fontFamily: "Arial, sans-serif",
};

export default arcadisTypography;
